import React from 'react';
import { 
  InversionLogoImg, 
  InversionColorGreenImg,
  InversionColorBlackImg
} from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { DownloadFile, Margin } from '@helpers';


export const InversionColor = ({getFileUrl, t}) => {
    return (
      <PageWrapper>
        <Container paddingTop='115px' marginLeft='130px' marginRight='42px' paddingBottom='168px'>
          <FlexDiv>
            <InversionLogoImg/>
            <Text width='338px' marginLeft='182px' marginTop='20px' paddingBefforeText="45px">
              <h1>{t("Icon color inversion")}</h1>
              <p>
                {t("When inverting the icon color, only one element of the icon is affected.")}
              </p>
            </Text>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' marginRight='52px' paddingBottom='110px'>
          <FlexDiv>
            <Text width='308px' paddingAffterText="40px" paddingBefforeText="45px">
              <h1>{t("Inversion logo colors")}</h1>
              <p>
                {t("Note that the inverted logo features gradients of white and green. This requirement is not subject to change.")}
              </p>
              <DownloadFile fileName='inversion_colors' file={getFileUrl("inversion_colors")} extension='.ai'/>
            </Text>
            <FlexDiv align='center'>
              <Margin marginLeft='48px'>
                <InversionColorGreenImg/>
              </Margin>
              <Margin marginLeft='42px'>
                <InversionColorBlackImg/>
              </Margin>
            </FlexDiv>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};
